import TextLocal from '@/src/textLocal/containers/TextLocal';

import css from '../../styles/PlusOne.module.css';

export const TEST_ID_COMPONENT = 'component';

const PlusOne = () => {
  return (
    <div className={css.plusOne} data-testid={TEST_ID_COMPONENT}>
      <div>+1</div>
      <div>
        <TextLocal id="wiki-how.thank-you" />
      </div>
    </div>
  );
};

export default PlusOne;
